import { ActionContext } from '../helpers/ActionContext';
import { IServerUserInfo } from '../models/IServerUserInfo';
import { IUserSettings } from '../models/IUserSettings';
import { Module } from '../Module';
import { ServerUsers } from '../resources/ServerUsers';
import { IConnectedDevice } from '../ServerApi/types/IConnectedDevice';
import { BrowserTitleService } from '../services/BrowserTitleService';
import { DeleteConnectedDeviceAction } from '../services/DeleteConnectedDeviceAction';
import { PersonalAccessTokensService } from '../services/PersonalAccessTokensService';
import { UserSettingsCtrlCommon } from '../services/UserSettingsCtrlCommon';

export class ServerUserSettingsSubplaceCtrl {

  public static $inject = [
    '$scope',
    'BrowserTitleService',
    'ServerUsers',
    'DeleteConnectedDeviceAction',
    'PersonalAccessTokensService',
    'UserSettingsCtrlCommon',
    // resolved in state router
    'isSessionUserSelf',
    'userSettings',
    'userRefreshTokenCount',
    'serverUser'
  ];

  constructor(
            $scope: ServerUserSettingsSubplaceCtrl.Scope,
            BrowserTitleService: BrowserTitleService,
            serverUsers: ServerUsers,
            deleteConnectedDeviceAction: DeleteConnectedDeviceAction,
            personalAccessTokensService: PersonalAccessTokensService,
            userSettingsCtrlCommon: UserSettingsCtrlCommon,
            isSessionUserSelf: boolean,
            userSettings: IUserSettings,
            userRefreshTokenCount: number,
            serverUser: IServerUserInfo
  ) {
    BrowserTitleService.setTitleWithPlaceEntityNameAndSubplaceName({placeEntityName: serverUser.displayName, translatableSubplaceName: 'serverSettings'});

    userSettingsCtrlCommon.initScope(
      $scope,
      isSessionUserSelf,
      serverUser,
      null, // There is no site user when displaying the server user setting page. Behavior needing the site user are disabled in that case (e.g. changing email address).
      userSettings,
      userRefreshTokenCount);

    // Connected devices

    const refreshTokensCallback = personalAccessTokensService.loadTokensIntoScope(<any>$scope, serverUser);

    const refreshConnectedDevices = () => serverUsers.getUserConnectedDevices(serverUser.id)
      .then((devices:IConnectedDevice[]) => $scope.connectedDevices = devices).then(refreshTokensCallback);

    $scope.deleteConnectedDevice = (device:IConnectedDevice, $event:JQueryEventObject) =>
      deleteConnectedDeviceAction.execute(device, serverUser.id, ActionContext.fromEvent($event))
        .then(refreshConnectedDevices);

    personalAccessTokensService.loadActionsIntoScope(<any>$scope, serverUser, isSessionUserSelf, refreshConnectedDevices);

    refreshConnectedDevices();

  }

}

export module ServerUserSettingsSubplaceCtrl {

  export interface Scope extends UserSettingsCtrlCommon.Scope {
    connectedDevices: IConnectedDevice[];
    deleteConnectedDevice(token: IConnectedDevice, $event: JQueryEventObject): void;
  }

}

Module.instance().controller('ServerUserSettingsSubplaceCtrl', ServerUserSettingsSubplaceCtrl);
